import { apiPut } from '../client';
import type { UpdatePasswordPayload, UpdatePasswordResponse } from '@/@types/account';
import type { ApiException } from '../client';

/**
 * Change user's password
 * Validates current password and updates to new password
 *
 * @param payload - Object containing current and new passwords
 * @returns Promise with success message
 * @throws ApiException with validation errors if request fails
 */
export async function updatePassword(payload: UpdatePasswordPayload): Promise<UpdatePasswordResponse> {
    try {
        return await apiPut<UpdatePasswordResponse>(
            '/app/v1/account/password',
            payload
        );
    } catch (error) {
        // Re-throw to allow component-level error handling
        throw error;
    }
}

/**
 * Hook to get validation errors from API exception
 */
export function getPasswordValidationErrors(error: any): Record<string, string> {
    const errors: Record<string, string> = {};

    if (error && typeof error === 'object' && 'errors' in error) {
        const apiError = error as ApiException;
        if (apiError.errors) {
            // Convert array of errors to first error message
            const errorFields = Object.keys(apiError.errors);
            errorFields.forEach((field) => {
                const messages = apiError.errors![field];
                if (messages && messages.length > 0) {
                    errors[field] = messages[0];
                }
            });
        }
    }

    return errors;
}

/**
 * Check if error is related to incorrect current password
 */
export function isCurrentPasswordError(error: any): boolean {
    if (error && typeof error === 'object') {
        const message = error.message || '';
        return message.toLowerCase().includes('current password');
    }
    return false;
}

